import React, { Component } from 'react';
import { CreditCard, CCBrand } from 'app-types';
import classNames from 'classnames';
import { Button, Icon } from 'components/antd';
import styles from './styles.module.scss';
import { padStartTwoSymbolsZero } from 'utils/utils';

interface Props {
	creditCard: CreditCard;
	isDeleted?: boolean;
	onRemoveItem?: () => void;
}

export default class CreditCardRow extends Component<Props> {
	render() {
		const { creditCard, isDeleted } = this.props;
		if (!creditCard) return null;
		return (
			<>
				<div className={styles.creditCardRow}>
					<span
						className={classNames(styles.creditCardLogo, {
							[styles.creditCardVisa]: creditCard.brand === CCBrand.visa,
							[styles.creditCardMasterCard]: creditCard.brand === CCBrand.masterCard,
							[styles.creditCardAmex]: creditCard.brand === CCBrand.americanExpress,
							[styles.creditCardDiscover]: creditCard.brand === CCBrand.discover,
							[styles.creditCardDiners]: creditCard.brand === CCBrand.dinersClub,
							[styles.creditCardJcb]: creditCard.brand === CCBrand.jcb,
							[styles.creditCardUnionpay]: creditCard.brand === CCBrand.unionPay,
						})}
					/>
					<span className={styles.creditCardDigits}>{creditCard.lastFourDigits}</span>
					<span className={styles.creditCardEpxiration}>
						{padStartTwoSymbolsZero(creditCard.expirationMonth)}/
						{creditCard.expirationYear}
					</span>

					{creditCard.isExpired && !isDeleted && (
						<span className={styles.creditCardStatus}>Expired</span>
					)}
					{isDeleted && <span className={styles.creditCardStatus}>Deleted</span>}
				</div>
				{!isDeleted && (
					<>
						<div className="removeButtonCol">
							<Button icon="remove" size="large" onClick={this.props.onRemoveItem} />
						</div>

						<Icon
							type="reorder"
							className={classNames(styles.creditCardIcon, {
								[styles.creditCardExpiredIcon]: creditCard.isExpired,
							})}
						/>
					</>
				)}
			</>
		);
	}
}
